import { motion } from "framer-motion";

const BRANCH_COLORS = ["#4F46E5", "#059669", "#D97706", "#E11D48", "#0891B2", "#7C3AED"];

export default function ConceptMap({ map }) {
  if (!map || !map.branches?.length) return null;
  return (
    <div className="space-y-4" data-testid="concept-map">
      <div className="flex justify-center">
        <div className="inline-flex items-center rounded-2xl bg-primary text-primary-foreground px-5 py-3 font-display font-extrabold text-base shadow-sm text-center max-w-md">
          {map.central}
        </div>
      </div>
      <div className="flex justify-center">
        <div className="h-6 w-px bg-border" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {map.branches.map((b, i) => {
          const color = BRANCH_COLORS[i % BRANCH_COLORS.length];
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25, delay: i * 0.06 }}
              className="rounded-2xl border-2 bg-card p-4 shadow-sm"
              style={{ borderColor: `${color}55` }}
              data-testid={`concept-branch-${i}`}
            >
              <div className="flex items-center gap-2 mb-1.5">
                <span className="h-3 w-3 rounded-full shrink-0" style={{ backgroundColor: color }} />
                <h4 className="font-display font-bold text-sm" style={{ color }}>{b.concept}</h4>
              </div>
              {b.description && <p className="text-xs text-muted-foreground mb-3">{b.description}</p>}
              {b.children?.length > 0 && (
                <ul className="space-y-1.5 pl-4 border-l-2" style={{ borderColor: `${color}33` }}>
                  {b.children.map((c, j) => (
                    <li key={j} className="text-sm">
                      <span className="font-medium">{c.concept}</span>
                      {c.description && <span className="text-muted-foreground"> — {c.description}</span>}
                    </li>
                  ))}
                </ul>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
